import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import GiewartowFormPage from '../sections/landing/order-forms/GiewartowFormPage';
import PolkolonieFormPage from '../sections/landing/order-forms/PolkolonieFormPage';
import ZieloneSzkolyFormPage from '../sections/landing/order-forms/ZieloneSzkolyFormPage';
import EndOfSeasonFormPage from '../sections/landing/order-forms/EndOfSeasonFormPage';
import EndOfPreSaleFormPage from '../sections/landing/order-forms/EndOfPreSaleFormPage';
import DocumentSigningPage from '../pages/guest/DocumentSigningPage';
import QualificationCardPage from '../sections/landing/order-forms/QualificationCardFormPage';
import SharedAccommodation from '../pages/employee/SharedAccommodation';
import WyjazdyRodzinneFormPage from '../sections/landing/order-forms/WyjazdyRodzinneFormPage';
import FormSentInfoOLRoute from '../components/form/FormSentInfoOLRoute';
import { LoginPage } from '../components/authorization/LoginPage';

export default () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} exact />
    <Route path="*" element={<Navigate to="/login" />} />
    <Route path="lato2026" element={<EndOfPreSaleFormPage formIdentifier={'lato'} boskieWakacje={false} />}/>
    <Route path="lato2026/:resort/:camp/:event" element={<EndOfPreSaleFormPage formIdentifier={'lato'} boskieWakacje={false} />}/>
    <Route path="lato2027" element={<GiewartowFormPage formIdentifier={'lato'} boskieWakacje={false} seasonYear={2027} />}/>
    <Route path="lato2027/:resort/:camp/:event" element={<GiewartowFormPage formIdentifier={'lato'} boskieWakacje={false} seasonYear={2027} />}/>

    <Route path="boskie-wakacje2026" element={<EndOfPreSaleFormPage formIdentifier={'lato'} boskieWakacje={true} />}/>
    <Route path="boskie-wakacje2026/:resort/:camp/:event" element={<EndOfPreSaleFormPage formIdentifier={'lato'} boskieWakacje={true} />}/>
    {/* <Route path="lato" element={<GiewartowFormPage formIdentifier={'lato'} boskieWakacje={false} />}/> */}
    {/* <Route path="lato/:resort/:camp/:event" element={<GiewartowFormPage formIdentifier={'lato'} boskieWakacje={false} />}/> */}
    <Route path="boskie-wakacje" element={<GiewartowFormPage formIdentifier={'lato'} boskieWakacje={true} />}/>
    <Route path="boskie-wakacje/:resort/:camp/:event" element={<GiewartowFormPage formIdentifier={'lato'} boskieWakacje={true} />}/>

    <Route path="zielone-szkoly" element={<ZieloneSzkolyFormPage formIdentifier={'zielone_szkoly'} year="2023" validPassword="zieloneszkoly2023sunsport" />}/>
    <Route path="polkolonie" element={<PolkolonieFormPage />}/>
    <Route path="wyjazdy-rodzinne" element={<WyjazdyRodzinneFormPage formIdentifier={'wyjazdy_rodzinne'} />}/>
    <Route path=":id/sign_document/:annex_nr/:model" element={<DocumentSigningPage />}/>
    <Route
      path=":id/sign_document/:annex_nr/:model/:module_identifier"
      element={<DocumentSigningPage />}
    />
    <Route path=":id/karta-kwalifikacyjna" element={<QualificationCardPage formIdentifier={'qualification_card'} year="2025" />}/>
    <Route path=":id/wspolne-zakwaterowanie" element={<SharedAccommodation />}/>
    <Route path="form-submitted" element={<FormSentInfoOLRoute/>}/>

  </Routes>
);
